import { AuthCredentials } from '@core/models/auth/auth-credentials';
import {
    LOGIN,
    LOGIN_COMPANY,
    LOGIN_ERROR,
    LOGIN_SSO,
    LOGIN_SUCCESSFUL,
    LOGIN_USER,
    LOGOUT,
    LOGOUT_POST
} from '@core/state/action-types';
import { ObservableAction } from '@core/state/shared/actions/observable-action';
import { Action } from '@ngrx/store';

@ObservableAction()
export class LoginAction implements Action {
    readonly type = LOGIN;

    constructor(public payload: AuthCredentials) {}
}

export class LoginSuccessAction implements Action {
    readonly type = LOGIN_SUCCESSFUL;

    constructor(public payload: any) {}
}

export class LoginErrorAction implements Action {
    readonly type = LOGIN_ERROR;
}

@ObservableAction()
export class LoginCompanyAction implements Action {
    readonly type = LOGIN_COMPANY;

    constructor(public payload: { 
        companyId: string,
        isChangingCompanies?: boolean,
        bypassRedirection?: boolean
    }) {}
}

@ObservableAction()
export class LoginSSOAction implements Action {
    readonly type = LOGIN_SSO;

    constructor(
        public payload: {
            ssoId: string;
            ssoProvider: string;
            redirect?: string;
            params?: any;
        }
    ) {}
}

export class LoginUserAction implements Action {
    readonly type = LOGIN_USER;

    constructor(public payload: any) {}
}

export class LogoutAction implements Action {
    readonly type = LOGOUT;
}

export class PostLogoutAction implements Action {
    readonly type = LOGOUT_POST;
}
